import termsApi from '../../api/terms.api';

const state = {
  term: {},
  terms: [],
  termsStatus: '',
};

const getters = {
  term: state => state.term,
  terms: state => state.terms,
  termsStatus: state => state.termsStatus,
};

const actions = {
  findAdminTerms({ commit }, payload) {
    commit('TERMS_STATUS', 'LOADING');
    return termsApi.findAdminTerms(payload)
      .then((response) => {
        commit('TERMS', response.terms);
        commit('TERMS_STATUS', 'FINISHED');
      });
  },

  getAdminTerm({ commit }, payload) {
    commit('TERMS_STATUS', 'LOADING');
    return termsApi.getAdminTerm(payload)
      .then((response) => {
        commit('TERM', response.term);
        commit('TERMS_STATUS', 'FINISHED');
      });
  },

  saveAdminTerm({ commit }, payload) {
    commit('TERMS_STATUS', 'LOADING');
    return termsApi.saveAdminTerm(payload)
      .then((response) => {
        commit('TERM', response.term);
        commit('TERMS_STATUS', 'FINISHED');
      });
  },
};

const mutations = {
  TERM(state, term) {
    state.term = term;
  },
  TERMS(state, terms) {
    state.terms = terms;
  },
  TERMS_STATUS(state, status) {
    state.termsStatus = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
